var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftwareGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.054 0V5.35134C25.054 6.69255 26.1451 7.78373 27.4863 7.78373H32.8377L25.054 0Z",
    fill: "#44BBA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4866 10.2163C24.8109 10.2163 22.6218 8.02709 22.6218 5.35141V0H3.16235V31.1351C3.16235 33.8108 5.35153 36 8.02721 36H27.9731C30.6488 36 32.838 33.8108 32.838 31.1351V10.2163H27.4866ZM14.2824 26.4293L12.4741 28.0566L7.36353 22.3783L12.4745 16.7L14.2828 18.3268L10.6362 22.3783L14.2824 26.4293ZM17.4563 28.0985L15.1382 27.361L18.5436 16.6582L20.8617 17.3957L17.4563 28.0985ZM23.5256 28.0567L21.7173 26.4294L25.3635 22.3785L21.7178 18.3276L23.5261 16.6998L28.6366 22.3781L23.5256 28.0567Z",
    fill: "#44BBA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareGreen);
export default __webpack_public_path__ + "static/media/software-green.22bee0abeed13db8d1d76bb27d87c3d0.svg";
export { ForwardRef as ReactComponent };